export enum ParkingType {
  ParkingUsage = 1,
  ParkingTransaction = 2,
}
